export const reportCategoryMap = {
  overspeed: [
    { key: 'Routes', required: false },
    { key: 'Vehicles', required: false },
    { key: 'Drivers', required: false },
  ],
  activity: [
    { key: 'Routes', required: true },
    { key: 'Vehicles' },
    { key: 'Drivers' },
    { key: 'Stops' },
  ],
  sos: [
    { key: 'Vehicles', required: true },
    { key: 'Drivers' },
  ],
  inventory: [
    { key: 'Devices', required: false },
    { key: 'Routes', required: false },
    { key: 'Vehicles', required: false },
    { key: 'Drivers', required: false },
    { key: 'Stops', required: false },
    { key: 'Users', required: false },
  ],
  runtime: [
    { key: 'Routes', required: false },
    { key: 'Vehicles', required: false },
    { key: 'Drivers', required: false },
  ],
  trip: [
    { key: 'Routes', required: false },
    { key: 'Vehicles', required: false },
    { key: 'Drivers', required: false },
  ],
  deviation: [
    { key: 'Routes', required: true },
    // { key: 'Vehicles', required: false },
    // { key: 'Drivers', required: false },
  ],
  halt:[
    { key: 'Vehicles', required: true },
    {key:'Routes', required: false},
    {key:'Drivers', required: false},
  ],
  entryExit:[
    { key: 'Vehicles', required: true },
    { key: 'Routes', required: false },
    { key: 'Stops', required: false },
  ]
};

export const reportApiMap = {
  overspeed: 'getOverspeedReport',
  activity: 'getActivityReport',
  sos: 'getSosReport',
  inventory: 'getInventoryReport',
  runtime: 'getRuntimeReport',
  trip: 'getTripReport',
  deviation: 'getRouteDeviationReport',
};
